import { gql, QueryHookOptions, useQuery } from '@apollo/client';

export const QUERY = gql`
  query getQuiz($id: ID!) {
    quiz(id: $id) {
      id
      title
      teamName
      sendCompletionEmailMode
      individualLink: link(respondentType: INDIVIDUAL)
      leaderLink: link(respondentType: LEADER)
      closed
      aiReportData
      isTeamReportApproved
      reportUrl
      zipReportUrl
      zipReportGeneratedAt
      client {
        id
        name
      }
      responses {
        id
        created
        respondentType
        respondentName
        reportUrl
        completitionEmailSentAt
        completitionEmailSentStatus
        isReportApproved
        aiReportData
      }
    }
  }
`;

export type Variables = {
  readonly id: string;
};

export type Response = {
  readonly quiz: {
    readonly id: string;
    readonly title: string;
    readonly individualLink: string;
    readonly teamName: string | null;
    readonly sendCompletionEmailMode: string | null;
    readonly leaderLink: string;
    readonly closed: string | null;
    readonly isTeamReportApproved?: boolean | null;
    readonly aiReportData?: Record<string, any> | null;
    readonly reportUrl: string | null;
    readonly zipReportUrl: string | null;
    readonly zipReportGeneratedAt: string | null;
    readonly client: {
      readonly id: string;
      readonly name: string;
    };
    readonly responses: readonly {
      readonly id: string;
      readonly created: string;
      readonly respondentType: string;
      readonly respondentName: string | null;
      readonly reportUrl: string | null;
      readonly completitionEmailSentAt: string | null;
      readonly completitionEmailSentStatus: string | null;
      readonly isReportApproved?: boolean | null;
      readonly aiReportData?: Record<string, any> | null;
    }[];
  };
};

export const useGetQuizQuery = (
  options?: QueryHookOptions<Response, Variables>,
) => useQuery<Response, Variables>(QUERY, options);
